import React from 'react';
import { useNavigate } from 'react-router-dom';
import './NotificationPromptModal.css';

function NotificationPromptModal({ onClose, onMarkSeen }) {
  const navigate = useNavigate();

  const handleGoToSettings = async () => {
    await onMarkSeen();
    navigate('/settings');
    onClose();
  };

  const handleGotIt = () => {
    onClose();
  };

  return (
    <div className="modal-overlay notification-prompt-overlay" onClick={handleGotIt}>
      <div
        className="modal-container notification-prompt-modal"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="notification-prompt-header">
          <h2>Stay in the Game! 🏉</h2>
          <button className="modal-close" onClick={handleGotIt} aria-label="Close">
            &times;
          </button>
        </div>

        <div className="notification-prompt-content">
          <p className="notification-prompt-intro">
            Never miss a pick with automatic email reminders
          </p>

          <div className="notification-features">
            <div className="notification-feature">
              <div className="feature-icon">📅</div>
              <div className="feature-text">
                <strong>Round Reminders</strong>
                <p>
                  Get notified 24 hours before each round starts if you haven't completed all your
                  picks
                </p>
              </div>
            </div>

            <div className="notification-feature">
              <div className="feature-icon">⏰</div>
              <div className="feature-text">
                <strong>Match Reminders</strong>
                <p>Get alerted 1 hour before each match if you haven't made your pick yet</p>
              </div>
            </div>
          </div>

          <div className="notification-prompt-actions">
            <button onClick={handleGotIt} className="btn btn-secondary">
              Got It
            </button>
            <button onClick={handleGoToSettings} className="btn btn-primary">
              Go to Settings
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default NotificationPromptModal;
